import { Chip } from "@mui/material";
import {
  TMaterialCategory,
  TMaterialCondition,
  TMaterialItemType,
  TMaterialStatus,
} from "../../../apis/material/material.interfaces";

export const materialStatusOptions: TMaterialStatus[] = [
  "available",
  "in-use",
  "maintenance",
  "retired",
];

export const materialCategoryOptions: TMaterialCategory[] = [
  "books",
  "equipment",
  "furniture",
  "stationery",
  "digital",
  "other",
];

export const materialConditionOptions: TMaterialCondition[] = [
  "excellent",
  "good",
  "fair",
  "poor",
];

export const materialItemTypeOptions: TMaterialItemType[] = [
  "book",
  "equipment",
  "stationery",
  "digital_resource",
];

const statusColor: Record<
  string,
  "default" | "primary" | "success" | "warning" | "info" | "error"
> = {
  available: "success",
  "in-use": "info",
  maintenance: "warning",
  retired: "default",
};

export const renderMaterialStatusChip = (status?: TMaterialStatus) => {
  if (!status) return null;
  return (
    <Chip
      size="small"
      label={formatLabel(status)}
      color={statusColor[status] ?? "default"}
      variant={status === "retired" ? "outlined" : "filled"}
    />
  );
};

export const formatLabel = (raw?: string) => {
  if (!raw) return "—";
  return raw
    .split(/[-_\s]/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};
